import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';


import * as billingDataFormConstants from './billingDataFormConstants';

import AddressForm, {addressFormConstants} from '../../Address/AddressForm';
import FormBlock from '../../../global/Form/FormBlock';
import FormCheckbox from '../../../global/Form/FormElement/FormCheckbox';
import FormTextInput from '../../../global/Form/FormElement/FormTextInput';
import FormTextarea from '../../../global/Form/FormElement/FormTextarea';
import ValidatingForm from '../../../global/Form/ValidatingForm';

import {I18nMessage} from '../../I18n';


function BillingDataForm({billingData, countryFilter, onChange}) {

    const {formatMessage} = useIntl();

    return (
        <ValidatingForm
            data={billingData}
            id={'billing.data.form'}
            onIsInvalid={data => onChange(data, false)}
            onIsValid={data => onChange(data, true)}
            validationSchema={billingDataFormConstants.SCHEMA_BILLING_DATA}
        >
            {({form}) => {

                const isBillingAddressMainAddress = form.getData('isBillingAddressMainAddress');

                return (
                    <>
                        <FormBlock>

                            <legend>
                                <I18nMessage id={'billing.data.form.recipient.legend'}/>
                            </legend>

                            <FormCheckbox
                                error={form.getCurrentError('isBillingAddressMainAddress')}
                                labelI18n={'billing.data.form.field.isBillingAddressMainAddress.label'}
                                id={'isBillingAddressMainAddress'}
                                isChecked={isBillingAddressMainAddress}
                                isLeft={true}
                                name={'isBillingAddressMainAddress'}
                                onChange={isBillingAddressMainAddress => {

                                    form.setData({
                                        address: isBillingAddressMainAddress
                                            ? undefined
                                            : addressFormConstants.SCHEMA_ADDRESS.getDefaultFromShape(),
                                        isBillingAddressMainAddress
                                    });
                                }}
                            />

                        </FormBlock>

                        {!isBillingAddressMainAddress && (
                            <AddressForm
                                address={form.getData('address')}
                                countryFilter={countryFilter}
                                hasName={true}
                                onChange={address => form.setData({address})}
                            />
                        )}

                        <FormBlock>
                            <legend>
                                <I18nMessage id={'billing.data.form.additional.legend'}/>
                            </legend>

                            <FormTextInput
                                error={form.getCurrentError('taxNumber')}
                                id={'taxNumber'}
                                isRequired={form.isRequired('taxNumber')}
                                labelI18n={'billing.data.form.field.taxNumber.label'}
                                maxLength={billingDataFormConstants.BILLING_DATA_TAX_NUMBER_MAX}
                                name={'taxNumber'}
                                onChange={taxNumber => form.setData({taxNumber})}
                                placeholder={formatMessage({id: 'billing.data.form.field.taxNumber.placeholder'})}
                                value={form.getData('taxNumber')}
                            />

                            <FormTextarea
                                error={form.getCurrentError('additionalInvoiceText')}
                                id={'additionalInvoiceText'}
                                isRequired={form.isRequired('additionalInvoiceText')}
                                labelI18n={'billing.data.form.field.additionalTransactionDocumentText.label'}
                                maxLength={billingDataFormConstants.BILLING_DATA_ADDITIONAL_TEXT_MAX}
                                name={'additionalInvoiceText'}
                                onChange={additionalInvoiceText => form.setData({additionalInvoiceText})}
                                placeholder={
                                    formatMessage({id: 'billing.data.form.field.additionalTransactionDocumentText.placeholder'})
                                }
                                value={form.getData('additionalInvoiceText')}
                            />

                        </FormBlock>
                    </>
                );
            }}
        </ValidatingForm>
    );
}


BillingDataForm.propTypes = {
    billingData: PropTypes.object,
    countryFilter: PropTypes.func,
    onChange: PropTypes.func.isRequired
};

BillingDataForm.defaultProps = {
    countryFilter: () => true
};


export default BillingDataForm;
